  <!-- Zápatí LHPO -->
<template>
  <div v-if="!NevybLhc" class="flex d-flex align-center">
    <v-tooltip top v-if="AppCategory == 'LHPO'">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon v-bind="attrs" v-on="on" class="mx-2" @click="LhcPorsObrsDoMapy('pors')">
          <v-icon color="">mdi-arrange-bring-forward </v-icon>
        </v-btn>
      </template>
      <span>Přidat porostní mapu vybraného Lhc do mapy</span>
    </v-tooltip>

    <v-tooltip top v-if="AppCategory == 'LHPO'">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon v-bind="attrs" v-on="on" class="mx-2" @click="LhcPorsObrsDoMapy('obrs')">
          <v-icon color="">mdi-vector-arrange-above </v-icon>
        </v-btn>
      </template>
      <span>Přidat obrysovou mapu vybraného Lhc do mapy</span>
    </v-tooltip>

    <v-tooltip top v-if="AppCategory == 'LHPO'">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon v-bind="attrs" v-on="on" class="mx-2" @click="LhcZoomCenter()">
          <v-icon color="">mdi-image-filter-center-focus </v-icon>
        </v-btn>
      </template>
      <span>Mapový výřez na střed vybraného Lhc</span>
    </v-tooltip>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon v-bind="attrs" v-on="on" class="mx-2 ml-8" color="accent" @click="LhcMajDoMapy()">
          <v-icon color="">mdi-arrange-bring-forward </v-icon>
        </v-btn>
      </template>
      <span>Přidat plošné zobrazení vybraného
        {{ NevybLhcMaj ? "Lhc" : "majetku" }} do mapy</span>
    </v-tooltip>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon v-bind="attrs" v-on="on" class="mx-1" color="accent" @click="LhcZoom()">
          <v-icon color="">mdi-arrow-expand-all </v-icon>
        </v-btn>
      </template>
      <span>Mapový výřez na
        {{ NevybLhcMaj ? "vybrané Lhc" : "vybraný majetek" }}</span>
    </v-tooltip>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on" class="d-flex ml-8">
          <v-avatar size="30" color="info">
            <v-icon dark> mdi-pine-tree </v-icon>
          </v-avatar>
          <span class="mx-2 align-self-center accent--text">{{
            VybLhc.LhcKod
          }}</span>
          <span class="mx-2 align-self-center primary--text">{{
            VybLhc.LhcNaz
          }}</span>
        </span>
      </template>
      <span>Vybrané Lhc</span>
    </v-tooltip>

    <v-tooltip top v-if="!NevybLhcMaj">
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on" class="d-flex ml-8">
          <v-avatar size="30" color="info">
            <v-icon dark> mdi-account </v-icon>
          </v-avatar>
          <span class="mx-2 align-self-center accent--text">{{
            VybLhc.MajKod
          }}</span>
          <span class="mx-2 align-self-center primary--text">{{
            VybLhc.MajNaz
          }}</span>
        </span>
      </template>
      <span>Vybraný majetek</span>
    </v-tooltip>

  <!-- 
  
  arrange-bring-forward 
  vector-arrange-above
  layers-plus
  map-plus
  

zoom (výřez)  arrow-expand-all
    -->

    <!-- Upozornění -->
    <v-dialog v-model="Alert_view" max-width="400">
      <v-alert class="pa-4 ma-0" type="error" dense icon="mdi-alert-circle-outline">{{ Alert_text }}
      </v-alert>
    </v-dialog>
  </div>
</template>

<script>
import ServiceLhpo from "../../services/ServiceLhpo";

export default {
  props: {
    // Jméno komponenty
    // CompName: { type: String },
    // Kategorie aplikace
    AppCategory: { type: String },
    // Adresa webové služby
    AppServiceurl: { type: Object },
    // Seznam  komponent
    CompList: { type: Array },
  },
  data() {
    return {
      // Upozornění
      Alert_view: false,
      // Upozornění - text
      Alert_text: "",

      // Pokus
      Pokus: null,
      // Opsaný obdelník vybraného Lhc
      VybLhcMbr: null,
    };
  },

  components: {},

  computed: {
    // Změna vybrané komponenty podle jména
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", {
          CompName: newValue,
          SlotName: this.CompList.find((item) => item.name == newValue).slot,
        });
      },
    },

    // Vybrané Lhc
    VybLhc: function () {
      return this.$store.getters.GET_sVybLhc;
    },

    // Zda je neybrané Lhc
    NevybLhc: function () {
      if (this.VybLhc.LhcKod == null) {
        return true;
      } else {
        return false;
      }
    },

    // Zda je neybrán majetek
    NevybLhcMaj: function () {
      if (this.VybLhc.MajKod == null) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    VybLhc: function (value) {
      this.NactiLhcMbr(value);
    },
  },

  methods: {
    // výřez podle majetku
    NactiLhcMbr: function (value) {
      ServiceLhpo.LhcMbr(value.Jid, value.MajKod, 3857)
        .then((response) => {
          if (response.data.Dokonceno) {
            this.VybLhcMbr = response.data.Mbr;
          } else {
            this.Alert_text = response.data.Chyba;
            this.Alert_view = true;
          }
        })
        .catch((error) => {
          console.log(error);
          //this.JprlVypisData = null;
        })
        .then(function () {
          // always executed
        });
    },

    // Porostka, Obrysovka do mapy
    LhcPorsObrsDoMapy: function (DruhMapy) {
      // Předpis vrstvy - stejné jako v MapComposition.json, podzději tam vytvořit vzorové předpisy a volat nějakou funkci

      var MapLegendLayer = {
        id: "Uhul_lhc-" + DruhMapy + "-" + this.VybLhc.Jid,
        removable: true,
        parentLegendGroup: "group_01_02",
        label:
          this.VybLhc.LhcKod +
          " (" +
          this.VybLhc.LhpOd +
          "-" +
          this.VybLhc.LhpDo +
          ")",
        labelsub:
          this.VybLhc.LhcNaz +
          "<br/>" +
          (this.VybLhc.LhcStav == "SchvalenyStav"
            ? "Schvalený stav"
            : "Souvislé zobrazení"),
        layerType: "STATIC",
        parentLayerGroup: "LayerGroup_Uhul_lhc_",
        maxScale: null,
        minScale: null,
        visible: true,
        type: null,
        legend: { image: "img/map/mapa_Uhul_Lho" + DruhMapy + ".png" },

        copyright: "nli",
        queryOption: {
          Id: this.VybLhc.Jid,
          Jid: this.VybLhc.Jid,
          SchvStav: this.VybLhc.SchvStav,
          Popis:
            this.VybLhc.LhcKod +
            " (" +
            (this.VybLhc.LhcStav == "SchvalenyStav"
              ? "Schvalený stav"
              : "Souvislé zobrazení") +
            ")",
        },
        category: "lhpo",
        wmts: null,
        mapyczimin: null,
      };

      switch (this.VybLhc.JidDs) {
        case "islh_lhc_data":
          // code block
          MapLegendLayer.parentLayerGroup += "data";
          MapLegendLayer.type = "Url";
          MapLegendLayer.url = {
            url:
              "https://mze.gov.cz/ssl/app/uhul/wmts_islh_lhc_data_" +
              DruhMapy +
              "/WMTService.aspx?",
            param:
              "SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&STYLE=default&FORMAT=image/png&TILEMATRIXSET=GoogleMapsCompatibleExt:epsg:3857&LAYER=" +
              this.VybLhc.LhcKod +
              "_" +
              this.VybLhc.Rocnik +
              "_" +
              this.VybLhc.ULhcStavS,
            tile: "&TILEMATRIX={z}&TILEROW={-y}&TILECOL={x}",
            levelcount: 22,
          };

          break;

        case "islh_lhc_1rok":
          MapLegendLayer.parentLayerGroup += "1rok";
          MapLegendLayer.type = "Url";
          MapLegendLayer.url = {
            url:
              "https://mze.gov.cz/ssl/app/uhul/wmts_islh_lhc_1rok_" +
              DruhMapy +
              "/WMTService.aspx?",
            param:
              "SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&STYLE=default&FORMAT=image/png&TILEMATRIXSET=GoogleMapsCompatibleExt:epsg:3857&LAYER=" +
              this.VybLhc.LhcKod +
              "_" +
              this.VybLhc.Rocnik +
              "_" +
              this.VybLhc.ULhcStavS,
            tile: "&TILEMATRIX={z}&TILEROW={-y}&TILECOL={x}",
            levelcount: 22,
          };

          break;

        case "islh_lhc_nsch":
          MapLegendLayer.parentLayerGroup += "nsch";
          MapLegendLayer.type = "Url";
          MapLegendLayer.url = {
            url:
              "https://mze.gov.cz/ssl/app/uhul/wmts_islh_lhc_nsch_" +
              DruhMapy +
              "/WMTService.aspx?",
            param:
              "SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&STYLE=default&FORMAT=image/png&TILEMATRIXSET=GoogleMapsCompatibleExt:epsg:3857&LAYER=" +
              this.VybLhc.LhcKod +
              "_" +
              this.VybLhc.Rocnik +
              "_" +
              this.VybLhc.ULhcStavS,
            tile: "&TILEMATRIX={z}&TILEROW={-y}&TILECOL={x}",
            levelcount: 22,
          };

          break;

        default:
      }

      // pustit mapu
      this.VybComp = "Map";

      this.$store.commit("SET_sMapAddLayer", MapLegendLayer);
    },

    // Plošné vylišení majetku do mapy
    LhcMajDoMapy: function () {
      // Předpis vrstvy - stejné jako v MapComposition.json, podzději tam vytvořit vzorové předpisy a volat nějakou funkci

      var idLayer =
        "Uhul_lhc-jprl-" +
        this.VybLhc.Jid +
        (this.VybLhc.MajKod ? "-" + this.VybLhc.MajKod : "");

      var idQuery =
        this.VybLhc.Jid + (this.VybLhc.MajKod ? "-" + this.VybLhc.MajKod : "");

      var label =
        this.VybLhc.LhcKod +
        " (" +
        this.VybLhc.LhpOd +
        "-" +
        this.VybLhc.LhpDo +
        ")";

      var labelsubLhc =
        this.VybLhc.LhcNaz +
        "<br/>" +
        (this.VybLhc.LhcStav == "SchvalenyStav"
          ? "Schvalený stav"
          : "Souvislé zobrazení");

      var labelsubMaj =
        this.VybLhc.MajNaz +
        " (" +
        this.VybLhc.MajKod +
        ")" +
        "<br/>" +
        (this.VybLhc.LhcStav == "SchvalenyStav"
          ? "Schvalený stav"
          : "Souvislé zobrazení");

      var parentLayerGroup= "LayerGroup_Uhul_lhc_jprl_";

      switch (this.VybLhc.JidDs) {
        case "islh_lhc_data":
        parentLayerGroup += "data";
          break;
        case "islh_lhc_1rok":
        parentLayerGroup += "1rok";
          break;
        case "islh_lhc_nsch":
        parentLayerGroup += "nsch";
          break;
        default:
      }

      var querylabelLhc =
        this.VybLhc.LhcKod +
        " (" +
        (this.VybLhc.LhcStav == "SchvalenyStav"
          ? "Schvalený stav"
          : "Souvislé zobrazení") +
        ")";

      var querylabelMaj = this.VybLhc.LhcKod + " majetek:" + this.VybLhc.MajKod;
      " (" +
        (this.VybLhc.LhcStav == "SchvalenyStav"
          ? "Schvalený stav"
          : "Souvislé zobrazení") +
        ")";

      var MapLegendLayer = {
        id: idLayer,
        removable: true,
        parentLegendGroup: "group_01_02",
        label: label,
        labelsub: this.VybLhc.MajKod ? labelsubMaj : labelsubLhc,
        layerType: "STATIC",
        parentLayerGroup: parentLayerGroup,
        maxScale: null,
        minScale: null,
        visible: true,
        type: "Gml",
        legend: { image: "img/map/mapa_Uhul_LhpoJprl_Green.png" },
        copyright: "nli",
        queryOption: {
          Id: idQuery,
          Jid: this.VybLhc.Jid,
          MajKod: this.VybLhc.MajKod,
          SchvStav: this.VybLhc.SchvStav,
          Popis: this.VybLhc.MajKod ? querylabelMaj : querylabelLhc,
        },
        category: "lhpo",
        gml: {
          url:
            this.AppServiceurl.ServiceLhpo +
            "/LhcGml?Jid=" +
            this.VybLhc.Jid +
            (this.VybLhc.MajKod ? "&MajKod=" + this.VybLhc.MajKod : "") +
            "&EpsgCode=3857",
          swapAxes: false,
        },
        featureOptions: {
          painter: "FP_Jprl",
          editable: false,
          hoverable: true
        }



      };

      // pustit mapu
      this.VybComp = "Map";

      this.$store.commit("SET_sMapAddLayer", MapLegendLayer);
    },

    // Výřez podle majetku
    LhcZoom: function () {
      this.$store.commit("SET_sMapMBR", {
        epsg: "EPSG:" + this.VybLhcMbr.EpsgCode,
        xmin: this.VybLhcMbr.Xmin,
        ymin: this.VybLhcMbr.Ymin,
        xmax: this.VybLhcMbr.Xmax,
        ymax: this.VybLhcMbr.Ymax,
      });
    },

    // Zoom na střed Lhc
    LhcZoomCenter: function () {
      this.$store.commit("SET_sMapMBR", {
        epsg: "EPSG:5514",
        xmin: this.VybLhc.Coordinate.X - 1000,
        ymin: this.VybLhc.Coordinate.Y - 1000,
        xmax: this.VybLhc.Coordinate.X + 1000,
        ymax: this.VybLhc.Coordinate.Y + 1000,
      });
    },
  },

  mounted() {
    // Nastavení služby
    ServiceLhpo.Init(this.AppServiceurl.ServiceLhpo);
  },
};
</script>